// TODO: remove eslint disable
/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as actions from "../../../store/actions/crm";
import Header from "components/complex/Header";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  ModalView
} from "components/simple";
import LoadingIndicator from "components/simple/LoadingIndicator/LoadingIndicator";
import { crm } from "router/routes";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import API from "api";
import SVG from "components/SVG";
import styles from "./styles.module.scss";
import { Input } from "../../../components/simple";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { formatDateToApi } from "helpers/formatter";
import Select from "components/simple/Select";
import { audienceFiltersStyles } from "helpers/select/styles/filters";

function isValidDate(date) {
  return (
    date &&
    Object.prototype.toString.call(date) === "[object Date]" &&
    !isNaN(date)
  );
}

function sortWithNull(arr, field, ascending = false) {
  if (typeof ascending === "undefined") ascending = true;

  const multiplier = ascending ? -1 : 1;

  const sorter = function(a, b, field) {
    if (a[field] === b[field]) {
      return 0;
    } else if (a[field] === null) {
      return 1 * multiplier;
    } else if (b[field] === null) {
      return -1 * multiplier;
    } else if (typeof a[field] === "number" && typeof b[field] === "number") {
      return (a[field] - b[field]) * multiplier;
    } else if (
      isValidDate(new Date(String(a[field]).replace(/\s/g, ""))) &&
      isValidDate(new Date(String(b[field]).replace(/\s/g, "")))
    ) {
      return String(a[field]).localeCompare(b[field]) * multiplier;
    } else if (
      isValidDate(new Date(String(a[field]).replace(/\s/g, ""))) &&
      !isValidDate(new Date(String(b[field]).replace(/\s/g, "")))
    ) {
      return -1;
    } else if (
      !isValidDate(new Date(String(a[field]).replace(/\s/g, ""))) &&
      isValidDate(new Date(String(b[field]).replace(/\s/g, "")))
    ) {
      return 1;
    } else {
      return a[field].localeCompare(b[field]) * multiplier;
    }
  };
  return arr.sort((a, b) => sorter(a, b, field));
}

const CompaniesList = props => {
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const dispatch = useDispatch();
  const { history } = props;
  const [isShownModal, setIsShownModal] = useState(false);
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null
  });
  /* eslint-disable */
  const openCompanyDetails = id => {
    history.push(`${crm}/company/${id}`);
  };

  const {
    companies,
    companiesLoading: isLoading,
    audienceActivity
  } = useSelector(state => state.crm);

  const {
    isDownloaded,
    errors,
    isActivityLoading,
    data,
    fileName
  } = audienceActivity;

  const { control, reset } = useForm();
  const resetFormAndToggleModal = () => {
    setIsShownModal(prev => !prev);
    reset({ start_date: "", end_date: "" });
    setDates({
      startDate: null,
      endDate: null
    });
    dispatch(actions.resetErrorsAudienceActivity());
  };

  useEffect(() => {
    if (
      isDownloaded &&
      !errors &&
      !isActivityLoading &&
      data &&
      fileName &&
      isShownModal
    ) {
      setIsShownModal(false);
      reset({ start_date: "", end_date: "" });
      setDates({
        startDate: null,
        endDate: null
      });
      const downloadLink = document.createElement("a");
      const blob = new Blob(["\ufeff", data]);
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }, [isActivityLoading, isDownloaded, errors]);
  const [filters, setFilters] = useState({
    label: "All",
    value: "All"
  });
  const [filtersCreatedBy, setFiltersCreatedBy] = useState([
    {
      label: "All",
      value: "All"
    }
  ]);
  const [tableData, setTableData] = useState([]);
  const [sortedTableData, setSortedTableData] = useState([]);
  const [searchBy, setSearchBy] = useState("");
  const [sortingOptions, setSortingOptions] = useState({
    fieldName: "name",
    isAscension: false
  });

  useEffect(() => {
    const arr = [];
    tableData.map(item => {
      if (item?.createdBy === null) {
        return arr.push({ label: "None", value: "None" });
      }
      return arr.push({ label: item?.createdBy, value: item?.createdBy });
    });
    setFiltersCreatedBy(prev => [
      ...prev,
      ...Array.from(new Set(arr.map(JSON.stringify))).map(JSON.parse)
    ]);
  }, [tableData]);

  const handleSorting = fieldName => {
    setSortingOptions({
      fieldName,
      isAscension:
        sortingOptions.fieldName === fieldName
          ? !sortingOptions.isAscension
          : false
    });
  };

  const onChangeFilter = (name, value) => {
    setFilters(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (value === "All") {
      setSortedTableData(tableData);
    } else if (value === "None") {
      setSortedTableData(tableData.filter(item => item.createdBy === null));
    } else {
      setSortedTableData(tableData.filter(item => item.createdBy === value));
    }
  };

  useEffect(() => {
    onChangeFilter("createdBy", "All");
  }, [tableData]);

  const getAudienceActivity = () => {
    API.crm.getAudienceActivity({ dates: dates });
  };

  const submit = () => {
    getAudienceActivity();
  };

  useEffect(() => {
    API.crm.getCompanies();
  }, []);
  useEffect(() => {
    const { fieldName, isAscension } = sortingOptions;
    let tableData = [
      ...companies.filter(({ name }) =>
        name.toLowerCase().match(`${searchBy.toLowerCase()}`, "gmi")
      )
    ];
    setTableData(sortWithNull(tableData, fieldName, isAscension));
  }, [companies, sortingOptions, searchBy]);

  const { fieldName, isAscension } = sortingOptions;

  return (
    <>
      <Container id="audiences" fluid>
        <div className="audiences-background">
          <div className="background-light" />
        </div>
        <Container className="audiences-container" fluid>
          <Row>
            <Header withoutSearchAndNotifications={false} />
          </Row>
          <Row className="audiences-dashboard">
            <div className="dashboard">
              <Col className="dashboard-container">
                <h1 className="title">Companies</h1>
                <p className="description">
                  Below are all companies you have created
                </p>
              </Col>
              <Col className="dashboard-container"></Col>
            </div>
          </Row>
          <Row className="audiences-tools">
            <div className="tools">
              <Link
                to={`${crm}/add-company`}
                className={"btn btn-primary d-flex align-items-center"}
              >
                Add Company
              </Link>
              <div className="ml-3">
                <Input
                  className="d-flex align-items-center"
                  handleChange={(name, text) => setSearchBy(text)}
                />
              </div>
              <div className={styles["select-wrapper"]}>
                <Select
                  label=""
                  containerClass="filter"
                  isSearchable={false}
                  styles={audienceFiltersStyles}
                  value={filters}
                  placeholder="Created By"
                  options={filtersCreatedBy}
                  name="createdBy"
                  handleChange={onChangeFilter}
                />
              </div>
              <div className={styles["btn-wrapper"]}>
                <Button
                  onClick={() => setIsShownModal(true)}
                  className="button add-button"
                >
                  <SVG.Plus className="icon" />
                  <span>Download report</span>
                </Button>
              </div>
            </div>
          </Row>
          <Row className="audiences-content">
            <Table className="table-striped">
              <thead>
                <tr>
                  <th scope="col" onClick={() => handleSorting("name")}>
                    <div className="d-flex flex-row">
                      <div className="d-flex align-items-center">
                        {fieldName === "name" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">Name</div>
                    </div>
                  </th>
                  <th scope="col" onClick={() => handleSorting("createdBy")}>
                    <div className="d-flex flex-row aligh-items-center">
                      <div className="d-flex align-items-center">
                        {fieldName === "createdBy" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        Created by
                      </div>
                    </div>
                  </th>
                  <th
                    scope="col"
                    onClick={() => handleSorting("expirationDate")}
                  >
                    <div className="d-flex flex-row aligh-items-center">
                      <div className="d-flex align-items-center">
                        {fieldName === "expirationDate" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        Expiration date
                      </div>
                    </div>
                  </th>
                  <th scope="col" onClick={() => handleSorting("lastSeen")}>
                    <div className="d-flex flex-row aligh-items-center">
                      <div className="d-flex align-items-center">
                        {fieldName === "lastSeen" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">Last Seen</div>
                    </div>
                  </th>
                  <th scope="col" onClick={() => handleSorting("totalUsers")}>
                    <div className="d-flex flex-row aligh-items-center">
                      <div className="d-flex align-items-center">
                        {fieldName === "totalUsers" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        Active/Total users
                      </div>
                    </div>
                  </th>
                  <th
                    scope="col"
                    onClick={() => handleSorting("totalClientsAmount")}
                  >
                    <div className="d-flex flex-row aligh-items-center">
                      <div className="d-flex align-items-center">
                        {fieldName === "totalClientsAmount" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        Active/Total clients
                      </div>
                    </div>
                  </th>
                  <th
                    scope="col"
                    onClick={() => handleSorting("activationsAmount")}
                  >
                    <div className="d-flex flex-row aligh-items-center">
                      <div className="d-flex align-items-center">
                        {fieldName === "activationsAmount" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        Activations
                      </div>
                    </div>
                  </th>
                  <th
                    scope="col"
                    onClick={() => handleSorting("audiencesAmount")}
                  >
                    <div className="d-flex flex-row aligh-items-center">
                      <div className="d-flex align-items-center">
                        {fieldName === "audiencesAmount" && (
                          <SVG.ArrowClient
                            className={
                              isAscension
                                ? styles["sort-arrow-ascending"]
                                : styles["sort-arrow-descending"]
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">Audiences</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="100%" style={{ textAlign: "center" }}>
                      <LoadingIndicator />
                    </td>
                  </tr>
                ) : (
                  sortedTableData.map(
                    (
                      {
                        name,
                        id,
                        activeUsers,
                        totalUsers,
                        lastSeen,
                        expirationDate,
                        createdBy,
                        activationsAmount,
                        audiencesAmount,
                        totalClientsAmount,
                        activeClientsAmount
                      },
                      index
                    ) => {
                      return (
                        <tr onClick={() => openCompanyDetails(id)} key={index}>
                          <td>{name}</td>
                          <td>{createdBy}</td>
                          <td>{expirationDate}</td>
                          <td>{lastSeen}</td>
                          <td>
                            {activeUsers}/{totalUsers}
                          </td>
                          <td>
                            {activeClientsAmount}/{totalClientsAmount}
                          </td>
                          <td>{activationsAmount}</td>
                          <td>{audiencesAmount}</td>
                        </tr>
                      );
                    }
                  )
                )}
              </tbody>
            </Table>
          </Row>
        </Container>
      </Container>
      <ModalView
        isOpen={isShownModal}
        toggle={resetFormAndToggleModal}
        handleClose={resetFormAndToggleModal}
        backdrop
        size="lg"
      >
        <div className={styles["picker-wrapper"]}>
          <Controller
            control={control}
            name="start_date"
            id="start_date"
            render={({ field }) => (
              <DatePicker
                className="form-control"
                ref={startDateRef}
                placeholderText="Select start date"
                maxDate={dates.endDate ? new Date(dates.endDate) : null}
                dateFormat="yyyy-MM-dd"
                onChange={date => {
                  field.onChange(date);
                  setDates(prev => {
                    return { ...prev, startDate: formatDateToApi(date) };
                  });
                }}
                selected={field.value}
              />
            )}
          />
          <Controller
            control={control}
            name="end_date"
            id="end_date"
            render={({ field }) => (
              <DatePicker
                className="form-control"
                ref={endDateRef}
                placeholderText="Select end date"
                minDate={dates.startDate ? new Date(dates.startDate) : null}
                dateFormat="yyyy-MM-dd"
                onChange={date => {
                  field.onChange(date);
                  setDates(prev => {
                    return { ...prev, endDate: formatDateToApi(date) };
                  });
                }}
                selected={field.value}
              />
            )}
          />
          <span className={styles["modal-error"]}>
            {audienceActivity?.errors}
          </span>
          <Button onClick={submit} className="button">
            <span>Download report</span>
          </Button>
        </div>
      </ModalView>
    </>
  );
};

export default CompaniesList;
